import { useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Seo } from "@/components/Seo";
import { api, errMsg } from "@/lib/api";
import site from "@/content/site.json";

const C = site.contact;
const TOPICS = ["General question", "Correction to a guide", "Calculator or data issue", "Account help", "Advertising or partnership"];
const EMPTY = { name: "", email: "", topic: TOPICS[0], message: "", website: "" };

export default function Contact() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/contact", f); setSent(true); setF(EMPTY); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-2xl fade-up" data-testid="contact-page">
      <Seo title={C.title} description={C.description} path="/contact" />
      <h1 className="text-4xl sm:text-5xl font-semibold text-grad-head" data-testid="page-title">{C.title}</h1>
      <p className="text-base text-muted-foreground mt-4">Questions about a calculator, a correction to one of our guides, or feedback on the app? Send us a note and the PillarWealth team at Atkins Media, LLC will reply by email, usually within two business days. Please don't include passwords or full account numbers.</p>
      {sent ? (
        <div className="glass p-6 mt-8" data-testid="contact-success"><p className="font-display text-lg font-semibold">Thanks, your message was sent.</p><p className="text-sm text-muted-foreground mt-1">We'll reply to the email address you gave us.</p></div>
      ) : (
        <form onSubmit={submit} className="glass p-6 sm:p-8 mt-8 space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-1.5"><Label htmlFor="c-name">Name</Label><Input id="c-name" required maxLength={80} value={f.name} onChange={set("name")} data-testid="contact-name-input" /></div>
            <div className="space-y-1.5"><Label htmlFor="c-email">Email</Label><Input id="c-email" type="email" required maxLength={120} value={f.email} onChange={set("email")} data-testid="contact-email-input" /></div>
          </div>
          <div className="space-y-1.5"><Label htmlFor="c-topic">Topic</Label>
            <select id="c-topic" value={f.topic} onChange={set("topic")} className="w-full h-10 rounded-md border border-input bg-background px-3 text-sm" data-testid="contact-topic-select">{TOPICS.map((t) => <option key={t}>{t}</option>)}</select>
          </div>
          <div className="space-y-1.5"><Label htmlFor="c-msg">Message</Label><Textarea id="c-msg" required minLength={10} maxLength={4000} rows={6} value={f.message} onChange={set("message")} data-testid="contact-message-input" /></div>
          <input type="text" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
          <Button type="submit" className="rounded-full" disabled={busy} data-testid="contact-submit-button"><PaperPlaneTilt size={16} className="mr-1.5" />{busy ? "Sending..." : "Send message"}</Button>
        </form>
      )}
    </div>
  );
}
